/*
jQuery(document).ready(function(){
  navDropdownLogic();
})

function navDropdownLogic(){
  let parentsWithChildren = jQuery('.main-menu li[class*="child-level"][class*="isDesktop"][class*="has-dropdown"]:not(.grand-child-level)');
  
  let dropDownId = 0;

  parentsWithChildren.each(function(){
    let thisLinkElem = jQuery(this).find('a');
    thisLinkElem.wrap('<div id="gl-dropdown-link-wrapper-'+dropDownId+'" class="gl-drop-down-link-wrapper"></div>');
    let thislinkElemWrapper = jQuery('#gl-dropdown-link-wrapper-'+dropDownId);
    let thisDropDownTriggerHTML = '<div id="gl-drop-down-trigger-'+dropDownId+'" class="gl-drop-down-trigger"><span>+</span></div>';
    thislinkElemWrapper.append(thisDropDownTriggerHTML);
    let thisDropDownTriggerElem = jQuery('#gl-drop-down-trigger-'+dropDownId);
    let thisParentsChildrenContainer = jQuery(this).find('ul');
    thisParentsChildrenContainer.hide();
    console.log('ddlength for #gl-drop-down-trigger-'+dropDownId, thisDropDownTriggerElem.length)
    thisDropDownTriggerElem.click(function(){
      console.log('clicked!')
      thisParentsChildrenContainer.toggle('slow');
    })
    dropDownId++;
  })
  
}
*/

jQuery(document).ready(function(){
  navDropdownLogic();
})

function navDropdownLogic(){
  let parentsWithChildren = jQuery('.main-menu li[class*="child-level"][class*="isDesktop"][class*="has-dropdown"]:not(.grand-child-level)');

  let dropDownId = 0;

  parentsWithChildren.each(function(){
    let thisLinkElem = jQuery(this).find('a');
    thisLinkElem.wrap('<div id="gl-dropdown-link-wrapper-'+dropDownId+'" class="gl-drop-down-link-wrapper"></div>');
    let thislinkElemWrapper = jQuery('#gl-dropdown-link-wrapper-'+dropDownId);
    let thisDropDownTriggerHTML = '<div id="gl-drop-down-trigger-'+dropDownId+'" class="gl-drop-down-trigger"><span>+</span></div>';
    thislinkElemWrapper.append(thisDropDownTriggerHTML);
    let thisDropDownTriggerElem = jQuery('#gl-drop-down-trigger-'+dropDownId);
    let thisDropDownTriggerSpan = thisDropDownTriggerElem.find('span'); // Get the span element
    let thisParentsChildrenContainer = jQuery(this).find('ul');
    thisParentsChildrenContainer.hide();
    console.log('ddlength for #gl-drop-down-trigger-'+dropDownId, thisDropDownTriggerElem.length)

    thisDropDownTriggerElem.click(function(){
      console.log('clicked!')
      thisParentsChildrenContainer.toggle('slow', function() {
        // Callback function after toggle animation completes
        if (thisParentsChildrenContainer.is(':visible')) {
          thisDropDownTriggerSpan.text('-'); // Change to minus when visible
        } else {
          thisDropDownTriggerSpan.text('+'); // Change to plus when hidden
        }
      });
    })
    dropDownId++;
  })

}

/**
   make divs equal heights
 **/
function equalHeightDivs(cssSelector, debug=false){

    let selectedDivs = jQuery(cssSelector);
    let tallestHeight = 0;

    selectedDivs.each(function(){
	let thisHeight = jQuery(this).outerHeight();
	if(debug){console.log('this height', thisHeight);};
	tallestHeight = (thisHeight > tallestHeight) ? thisHeight : tallestHeight;
	if(debug){console.log('tallest height', tallestHeight);};
    })

    selectedDivs.each(function(){
	jQuery(this).css({ "min-height" : tallestHeight + "px" })
	if(debug){ console.log('setting min height of ' + tallestHeight + 'px for: ', jQuery(this)); };
    })
    
};

// call like this:
// equalHeightDivs('.the-div-class');

/**
  Force PDF files to open in new window
 */
document.addEventListener("DOMContentLoaded", function() {
   document.querySelectorAll('a[href$=".pdf"]').forEach(function(link) {
      console.log('[Gridlink] - added target="_blank" to a PDF file on this page...');
     link.setAttribute("target", "_blank");
     link.setAttribute("rel", "noopener");
   });
});

/**
 * Close filters on collection pages by default for mobile
 */
jQuery(document).ready(function(){
  if (jQuery('#collection-grid > #sorting > details').length > 0){
    if (window.innerWidth < 600){
      jQuery('#collection-grid > #sorting > details').removeAttr('open')
      console.log('[Gridlink] - Closed filters...')
    }
  }
})

/**
 * SparkLayer helpers
 *
 * These selectors are native retail-theme elements that should be hidden when
 * SparkLayer switches a logged-in B2B customer into the B2B interface.
 */
(function ($) {
  if (!$) {
    return;
  }

  var b2cOnlySelectors = [
    '.tab-body .additional',
    '#shopify-section-template--18141889855662__section_rich_text_KUwnEX',
    '#shopify-section-template--18141889855662__section_shop_look_atFrfW',
    '#shopify-section-template--18141889855662__section_collection_fMRRNq',
    '#cart-dropdown'
  ];

  function markB2COnlyElements() {
    b2cOnlySelectors.forEach(function (selector) {
      $(selector).attr('data-spark', 'b2c-only');
    });
  }

  $(document).ready(markB2COnlyElements);
  document.addEventListener('shopify:section:load', markB2COnlyElements);
})(window.jQuery);
